import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Sparkles } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * In-feed promo card: encourages residents to add their own activity.
 *
 * Placed after the 3rd activity in the feed so the user has already seen
 * social-proof (real activities, real organizers) before being asked to
 * contribute. Coral-on-cream styling sets it apart from regular cards.
 */
const OrganizeYourselfCTA = () => {
  const dest = '/activiteit-toevoegen';

  return (
    <div
      className="relative bg-gradient-to-br from-hoi-coral/10 via-white to-hoi-yellow/20 border border-hoi-coral/20 p-6 sm:p-8 max-w-lg mx-auto lg:max-w-none rounded-3xl shadow-sm"
      data-testid="home-organize-cta"
    >
      <div className="flex items-start gap-4">
        <div className="hidden sm:flex w-12 h-12 rounded-full bg-hoi-coral/15 items-center justify-center flex-shrink-0">
          <Sparkles className="w-6 h-6 text-hoi-coral" aria-hidden="true" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-heading font-bold text-xl text-primary mb-2 leading-tight">
            Organiseer jij iets in de buurt?
          </h3>
          <p className="text-sm text-gray-600 mb-4 leading-relaxed">
            Een koffieochtend, wandelclub of klusgroep, deel het hier en je buren weten je te vinden.
            Het kost 2 minuten.
          </p>
          <Link to={dest}>
            <Button
              className="rounded-full bg-hoi-coral hover:bg-hoi-coral/90 text-white font-heading px-5 py-3 shadow-md shadow-hoi-coral/25 active:scale-95 transition-transform"
              data-testid="home-organize-cta-btn"
            >
              <Plus className="w-4 h-4 mr-1.5" aria-hidden="true" />
              Plaats je activiteit
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrganizeYourselfCTA;
